import React from "react";

import type { MetricQuery } from "~/models/metric-query";
import type { BoundMetricChartType } from "~/tools/bound-metric";
import type { Time } from "~/tools/date-time/time";
import type { Impulse } from "~/tools/impulse";

import type { TimeRange } from "../../../../../../app/state/view/timeline/TimeRange";
import { ThumbnailTimeSeriesChart } from "../../../../../../components/react/metrics/ThumbnailTimeSeriesChart";

export interface PinnedMetricComponent {
	identifier: string;
	type: string;
	name: string;
}

export interface PinnedMetric {
	name?: string;
	description?: string;
	component: PinnedMetricComponent;
	chartType: BoundMetricChartType;
	unit?: string;
	metricQueries: ReadonlyArray<MetricQuery>;
}

export interface MetricProps {
	timeRange: Impulse<TimeRange>;
	metric: PinnedMetric;
	markerTimestamp?: Time;
}

export const Metric: React.FC<MetricProps> = ({ timeRange, markerTimestamp, metric }) => (
	<ThumbnailTimeSeriesChart
		batch={metric.name ?? false}
		chartType={metric.chartType}
		markerTimestamp={markerTimestamp}
		metricQueries={metric.metricQueries}
		timeRange={timeRange}
		unit={metric.unit}
	/>
);
